function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { hideModal } from '../../redux/actions';
import text from '../../text';
import Icon from '../icon/Icon';
import routes from '../../routes/constants';
export var PAYMENT_FAILURE_MODAL = 'PAYMENT_FAILURE_MODAL';
var PaymentFailureModal = function(props) {
    var dispatch = useDispatch();
    var handleHide = function() {
        return dispatch(hideModal(PAYMENT_FAILURE_MODAL));
    };
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        centered: true,
        className: "PaymentFailureModal",
        onHide: handleHide
    }, props), /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-exclamation"
    })), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("h2", null, props.message), /*#__PURE__*/ React.createElement("div", null, text('paymentHelp', {
        contactUs: /*#__PURE__*/ React.createElement(Link, {
            key: "urlTerms",
            to: {
                pathname: routes.larkiWebsiteUrl.contactUs
            },
            target: '_blank'
        }, text('contactUs'))
    }))));
};
export default PaymentFailureModal;
